import { Injectable } from '@angular/core';
import { MessageService } from '@services/helpers/message-service/message.service';
import { MailsDataProvider } from '@services/email/mails.data.service';
import { EmailServiceProvider } from '@services/email/email-service/email.service';
import { StringModifierServiceProvider } from '@services/helpers/string-modifier-service/stringModifier.service';
import { Mail } from '@models/models';

interface MailData {
	chosenEmail: any;
	chosenQuestionnaire?: any;
}

interface MessageParametres {
	messageData: Mail;
	jobId: number;
	mailData: MailData;
	showCcField: boolean;
	questionnaireId?: number;
}

interface DataToSend {
	emailTo: string;
	emailCc: string;
	emailText: string;
	emailSubject: string;
	questionnaireTemplateId: number | null;
	jobId: number;
	templateId: number;
}

@Injectable()
export class QuestionnairesServiceProvider {
	constructor(
		private messageService: MessageService,
		private mailsDataService: MailsDataProvider,
		private emailService: EmailServiceProvider,
		private stringModifierService: StringModifierServiceProvider
	) {}

	setDefaultEmail(emails: Array<any>) {
		if (emails !== undefined && emails !== null && emails.length) {
			return (
				emails.find(
					item => item.emailTemplateType === 'QUESTIONNAIRE_EMAIL_TEMPLATE'
				) || {}
			);
		}
		return null;
	}

	successSendEmail() {
		this.messageService.showToaster('s_9', 'jobView');
		this.mailsDataService.emitMailUpdateEvent(true);
	}

	errorSendMessage(result, emailTo: string, activeView: string): void {
		const { status, data } = result;
		const errorMessage = data.errorMessage;
		if (status >= 400 && status < 500 && errorMessage) {
			if (errorMessage.includes('Email address inactive')) {
				this.messageService.showToaster('e_1', 'generalValidation', emailTo);
			} else if (activeView.includes('JobProfilePage')) {
				this.messageService.showToaster('e_0', 'questionnaires');
			} else if (
				errorMessage.includes('Email text should contain a questionnaire link')
			) {
				this.messageService.showToaster('e_0', 'questionnaires');
			} else {
				this.messageService.showToaster('e_2', 'general', errorMessage);
			}
		} else {
			this.messageService.showToaster('e_0', 'general');
		}
	}

	gatherDataToSendQuest(data: MessageParametres, isNew: boolean) {
		const { messageData, jobId, mailData, showCcField, questionnaireId } = data;
		const { attachmentsData } = messageData;
		const { storedFiles, uploadedFiles } = this.emailService.prepareAttachments(
			attachmentsData
		);

		let sendMessageData;
		if (isNew) {
			sendMessageData = this.prepareNewQuestMailToSend(
				messageData,
				jobId,
				mailData,
				showCcField
			);
		} else {
			sendMessageData = this.prepareExistingQuestMailToSend(
				messageData,
				jobId,
				mailData,
				showCcField,
				questionnaireId
			);
		}

		return {
			sendMessageData,
			storedFiles,
			uploadedFiles
		};
	}

	prepareQuestToSave(questionnaire) {
		if (questionnaire && questionnaire.name) {
			questionnaire.name = this.stringModifierService.cutSelectedText(
				questionnaire.name
			);
		}
		return questionnaire;
	}

	private prepareNewQuestMailToSend(
		messageData,
		jobId,
		mailData,
		showCcField
	): DataToSend {
		const emailCC2save = showCcField ? messageData.emailCc : '';

		const result: DataToSend = {
			emailTo: messageData.emailTo,
			emailCc: emailCC2save,
			emailText: messageData.emailText || '',
			emailSubject: messageData.emailSubject,
			questionnaireTemplateId: mailData.chosenQuestionnaire
				? mailData.chosenQuestionnaire.id
				: null,
			jobId,
			templateId: mailData.chosenEmail.id
		};

		return result;
	}

	private prepareExistingQuestMailToSend(
		messageData,
		jobId,
		mailData,
		showCcField,
		questionnaireId
	): DataToSend {
		const emailCC2save = showCcField ? messageData.emailCc : '';

		const result: DataToSend = {
			emailTo: messageData.emailTo,
			emailCc: emailCC2save,
			emailText: messageData.emailText || '',
			emailSubject: messageData.emailSubject,
			questionnaireTemplateId: questionnaireId,
			jobId,
			templateId: mailData.chosenEmail.id
		};

		return result;
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=nfw9yna8xro!./shared/services/questionnarie/questionnaires-service/questionnaires.service.ts